// app/javascript/application.js

import "./controllers"



document.addEventListener("DOMContentLoaded", () => {
  (async () => {
    try {
      // Dynamically import Bootstrap components
      const { Dropdown, Collapse, Modal, Toast } = await import('./vendors/bootstrap');

      // Initialize dropdowns
      document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach(el => {
        new Dropdown(el);
      });

      // Note: Collapse/Accordion works automatically with data-bs-toggle="collapse"
      // No manual initialization needed

      // Initialize all flash toasts
      const toastElList = [].slice.call(document.querySelectorAll('.toast'));
      toastElList.forEach(toastEl => {
        new Toast(toastEl).show();
      });

      // Handle auto-appointment modal
      const autoModalElement = document.getElementById('autoappointmentModal');
      const appointmentModalElement = document.getElementById('appointmentModal');

      if (autoModalElement && sessionStorage.getItem('promoModalClosed') !== 'true') {
        setTimeout(() => {
          if (autoModalElement.classList.contains('show')) return;
          if (appointmentModalElement && appointmentModalElement.classList.contains('show')) return;

          const autoModal = new Modal(autoModalElement);
          autoModal.show();

          autoModalElement.addEventListener('hidden.bs.modal', () => {
            sessionStorage.setItem('promoModalClosed', 'true');
          });
        }, 60000); // Show after 60 seconds
      }

    } catch (err) {
      console.error("Bootstrap dynamic import or initialization failed:", err);
    }
  })();
});


document.addEventListener("DOMContentLoaded", () => {
  const menu         = document.querySelector(".menu");
  const menuSection  = menu?.querySelector(".menu-section");
  const menuArrow    = menu?.querySelector(".menu-mobile-arrow");
  const menuClosed   = menu?.querySelector(".menu-mobile-close");
  const menuTrigger  = document.querySelector(".menu-mobile-trigger");
  const menuOverlay  = document.querySelector(".overlay");
  const menuHeader   = menu?.querySelector(".menu-mobile-header");
  const navbar       = document.querySelector(".navbar-area #navbar");
  const progressPath = document.getElementById("progress-path");
  const progressWrap = document.getElementById("progress-wrap");
  const counters     = document.querySelectorAll(".counter");
  let previousMenu = [];
  let pathLength;

  // --- Menu ---
  function toggleMenu() {
    menu?.classList.toggle("active");
    menuOverlay?.classList.toggle("active");

    if (!menu?.classList.contains("active")) resetMenu();
  }
  function showSubMenu(parent) {
    const subMenu = parent.querySelector(".menu-subs");
    if (!subMenu) return;
    previousMenu.push(subMenu);
    subMenu.classList.add("active", "slide-left");
    menuHeader?.classList.add("active");
    menuArrow?.classList.remove("hidden");
  }
  function hideSubMenu() {
    if (!previousMenu.length) return;
    const subMenu = previousMenu.pop();
    subMenu.classList.add("slide-right");
    setTimeout(() => {
      subMenu.classList.remove("active", "slide-right");
    }, 300);
    if (!previousMenu.length) {
      menuHeader?.classList.remove("active");
      menuArrow?.classList.add("hidden");
    }
  }
  function resetMenu() {
    previousMenu = [];
    menuHeader?.classList.remove("active");
    menuArrow?.classList.add("hidden");
    menu?.querySelectorAll(".menu-subs.active")
        .forEach(s => s.classList.remove("active"));
  }
  // --- Sticky Navbar ---
  function handleStickyNav() {
    const height = 150;
    navbar?.classList.toggle("sticky", window.scrollY >= height);
  }
  // --- Back to Top Progress ---
  function initProgressPath() {
    if (!progressPath) return;
    pathLength = progressPath.getTotalLength();
    progressPath.style.strokeDasharray = `${pathLength} ${pathLength}`;
    progressPath.style.strokeDashoffset = pathLength;
  }
  function updateProgress() {
    if (!progressPath || !progressWrap) return;
    const scroll  = window.scrollY;
    const height  = document.body.scrollHeight - window.innerHeight;
    const offset  = 50;
    const progress = pathLength - (scroll * pathLength) / height;
    progressPath.style.strokeDashoffset = progress;
    progressWrap.classList.toggle("active-progress", scroll > offset);
  }
  // --- Counters ---
  function initCounters() {
    if (!("IntersectionObserver" in window)) return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const counter = entry.target;
          const target  = parseInt(counter.innerText, 10) || 0;
          const step    = target / 200;
          let current   = 0;
          const timer = setInterval(() => {
            current += step;
            counter.innerText = Math.min(Math.floor(current), target);
            if (current >= target) clearInterval(timer);
          }, 10);
          observer.unobserve(counter);
        }
      });
    });
    counters.forEach(c => observer.observe(c));
  }
  // --- Event Listeners ---
  menuSection?.addEventListener("click", e => {
    if (!menu?.classList.contains("active")) return;
    const parent = e.target.closest(".menu-item-has-children");
    if (parent) showSubMenu(parent);
  });
  [menuArrow, menuClosed, menuTrigger, menuOverlay].forEach(el =>
    el?.addEventListener("click", toggleMenu)
  );
  window.addEventListener("resize", () => {
    if (window.innerWidth > 991 && menu?.classList.contains("active")) {
      toggleMenu();
    }
  });
  progressWrap?.addEventListener("click", e => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: "smooth" });
  });
  // --- Init ---
  initProgressPath();
  initCounters();
  // Scroll handling with rAF
  let ticking = false;
  window.addEventListener("scroll", () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        handleStickyNav();
        updateProgress();
        ticking = false;
      });
      ticking = true;
    }
  });
  // Initial run
  handleStickyNav();
  updateProgress();
});
